module.exports = __webpack_public_path__ + "img/New Caledonia.aa79bf2b.svg";